import { IngredientDetailsViewModel } from "../types/ingredientDetailsView.types";

interface IngredientUnitBadgeProps {
  vm: IngredientDetailsViewModel;
}

/**
 * Right-aligned "UNIT / 1 kg" block passed as `TailwindSideModal`'s
 * `headerRight`, matching the Lovable prototype. Trailing spacer leaves room
 * for the Sheet's absolute-positioned close button, same convention as
 * `ProductDetailsModal`'s `headerRight`.
 */
const IngredientUnitBadge = ({ vm }: IngredientUnitBadgeProps) => {
  const details = vm.ingredientDetails?.supplierIngredientDetails;

  return (
    <>
      <div className="tw-text-right">
        <p className="tw-mb-0.5 tw-text-[10px] tw-font-medium tw-uppercase tw-tracking-wider tw-text-muted-foreground">
          Unit
        </p>
        <p className="tw-font-mono tw-text-base tw-text-foreground">
          {details?.unit_size ?? "-"} {details?.unit_type ?? ""}
        </p>
      </div>
      <span className="tw-w-4" />
    </>
  );
};

export default IngredientUnitBadge;
